import { BottomSheet, DatePickerCalendar, TypeDatePickerCalendarRendererProps } from '@thefarmersfront/kitchen-mobile';

/** @description 날짜 선택 바텀시트 */
const DatePickerBottomSheet = ({
  id,
  title,
  isCalendarOpen,
  setIsCalendarOpen,
  calendarConfig,
  onConfirm,
}: TypeDatePickerCalendarRendererProps & { id: string; title?: string }) => {
  return (
    <BottomSheet
      id={id}
      title={title}
      open={isCalendarOpen}
      onClose={() => setIsCalendarOpen(false)}
      buttonConfig={{
        buttonType: 'alert',
        confirmText: '선택',
        onConfirm,
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <DatePickerCalendar {...calendarConfig} />
      </div>
    </BottomSheet>
  );
};

export default DatePickerBottomSheet;
